import {
  ADD_ADMISSION_FAILURE,
  ADD_ADMISSION_REQUEST,
  ADD_ADMISSION_SUCCESS,
  DELETE_ADMISSION_FAILURE,
  DELETE_ADMISSION_REQUEST,
  DELETE_ADMISSION_SUCCESS,
  EDIT_ADMISSION_FAILURE,
  EDIT_ADMISSION_REQUEST,
  EDIT_ADMISSION_SUCCESS,
  FETCH_ADMISSION_FAILURE,
  FETCH_ADMISSION_PARTICULAR_FAILURE,
  FETCH_ADMISSION_PARTICULAR_REQUEST,
  FETCH_ADMISSION_PARTICULAR_SUCCESS,
  FETCH_ADMISSION_PATIENT_FAILURE,
  FETCH_ADMISSION_PATIENT_REQUEST,
  FETCH_ADMISSION_PATIENT_SUCCESS,
  FETCH_ADMISSION_REQUEST,
  FETCH_ADMISSION_SUCCESS,
  FETCH_ADMISSIONS_BY_PHONE_NUMBER_FAILURE,
  FETCH_ADMISSIONS_BY_PHONE_NUMBER_REQUEST,
  FETCH_ADMISSIONS_BY_PHONE_NUMBER_SUCCESS,
  FETCH_ALL_LIST_ADMISSIONS_FAILURE,
  FETCH_ALL_LIST_ADMISSIONS_REQUEST,
  FETCH_ALL_LIST_ADMISSIONS_SUCCESS,
  FETCH_ALLS_LIST_ADMISSIONS_FAILURE,
  FETCH_ALLS_LIST_ADMISSIONS_REQUEST,
  FETCH_ALLS_LIST_ADMISSIONS_SUCCESS,
  FETCH_LIST_ADMISSIONS_FAILURE,
  FETCH_LIST_ADMISSIONS_REQUEST,
  FETCH_LIST_ADMISSIONS_SUCCESS,
  FETCH_REPORT_LIST_ADMISSIONS_FAILURE,
  FETCH_REPORT_LIST_ADMISSIONS_REQUEST,
  FETCH_REPORT_LIST_ADMISSIONS_SUCCESS,
  RESET_ADMISSION_PARTICULAR,
  RESET_ADMISSIONS_BY_PHONE_NUMBER,
  RESET_CURRENT_ADMISSION,
  UPDATE_ADMISSION_FAILURE,
  UPDATE_ADMISSION_REQUEST,
  UPDATE_ADMISSION_SUCCESS,
  BULK_DISCHARGE_ADMISSION_REQUEST,
  BULK_DISCHARGE_ADMISSION_SUCCESS,
  BULK_DISCHARGE_ADMISSION_FAILURE
} from "./admissionsType";

export const fetchAdmissions = (pageNo) => ({
  type: FETCH_LIST_ADMISSIONS_REQUEST,
  payload: pageNo,
});

export const fetchAdmissionsSuccess = (admissions) => ({
  type: FETCH_LIST_ADMISSIONS_SUCCESS,
  payload: { admissions },
});

export const fetchAdmissionsFailure = (error) => ({
  type: FETCH_LIST_ADMISSIONS_FAILURE,
  payload: { error },
});

export const fetchAllAdmissions = (pageNo) => ({
  type: FETCH_ALL_LIST_ADMISSIONS_REQUEST,
  payload: pageNo,
});

export const fetchAllAdmissionsSuccess = (admissions) => ({
  type: FETCH_ALL_LIST_ADMISSIONS_SUCCESS,
  payload: { admissions },
});

export const fetchAllAdmissionsFailure = (error) => ({
  type: FETCH_ALL_LIST_ADMISSIONS_FAILURE,
  payload: { error },
});

export const fetchAllAdmission = (pageNo) => ({
  type: FETCH_ALLS_LIST_ADMISSIONS_REQUEST,
  payload: pageNo,
});

export const fetchAllAdmissionsSucces = (admissions) => ({
  type: FETCH_ALLS_LIST_ADMISSIONS_SUCCESS,
  payload: { admissions },
});

export const fetchAllAdmissionsFailures = (error) => ({
  type: FETCH_ALLS_LIST_ADMISSIONS_FAILURE,
  payload: { error },
});
export const fetchAllReportList = (pageNo) => ({
  type: FETCH_REPORT_LIST_ADMISSIONS_REQUEST,
  payload: pageNo,
});

export const fetchReportListSuccess = (admissions) => ({
  type: FETCH_REPORT_LIST_ADMISSIONS_SUCCESS,
  payload: { admissions },
});

export const fetchReportListFailure = (error) => ({
  type: FETCH_REPORT_LIST_ADMISSIONS_FAILURE,
  payload: { error },
});

export const fetchAdmission = (admissionId, status) => {
  return {
    type: FETCH_ADMISSION_REQUEST,
    payload: { admissionId, status },
  };
};

export const fetchAdmissionSuccess = (admissions) => {
  return {
    type: FETCH_ADMISSION_SUCCESS,
    payload: { admissions },
  };
};

export const fetchAdmissionFailure = (error) => {
  return {
    type: FETCH_ADMISSION_FAILURE,
    payload: { error },
  };
};

export const fetchAdmissionPatient = (admissionId) => {
  return {
    type: FETCH_ADMISSION_PATIENT_REQUEST,
    payload: { admissionId },
  };
};

export const fetchAdmissionPatientSuccess = (admissions) => {
  return {
    type: FETCH_ADMISSION_PATIENT_SUCCESS,
    payload: { admissions },
  };
};

export const fetchAdmissionPatientFailure = (error) => {
  return {
    type: FETCH_ADMISSION_PATIENT_FAILURE,
    payload: { error },
  };
};

export const addAdmission = (admissionData) => ({
  type: ADD_ADMISSION_REQUEST,
  payload: { admissionData },
});

export const addAdmissionSuccess = (admission) => ({
  type: ADD_ADMISSION_SUCCESS,
  payload: { admission },
});

export const addAdmissionFailure = (error) => ({
  type: ADD_ADMISSION_FAILURE,
  payload: { error },
});

export const updateAdmission = (admissionId, admissionData) => {
  return {
    type: UPDATE_ADMISSION_REQUEST,
    payload: { admissionId, admissionData },
  };
};

export const updateAdmissionSuccess = (admission) => ({
  type: UPDATE_ADMISSION_SUCCESS,
  payload: { admission },
});

export const updateAdmissionFailure = (error) => ({
  type: UPDATE_ADMISSION_FAILURE,
  payload: { error },
});

export const deleteAdmission = (admissionId) => {
  return {
    type: DELETE_ADMISSION_REQUEST,
    payload: { admissionId },
  };
};
export const deleteAdmissionSuccess = (admissionId) => ({
  type: DELETE_ADMISSION_SUCCESS,
  payload: { admissionId },
});

export const deleteAdmissionFailure = (error) => ({
  type: DELETE_ADMISSION_FAILURE,
  payload: { error },
});

export const resetCurrentAdmission = () => ({
  type: RESET_CURRENT_ADMISSION,
});

export const fetchAdmissionsByPhoneNumber = (phoneNumber) => ({
  type: FETCH_ADMISSIONS_BY_PHONE_NUMBER_REQUEST,
  payload: { phoneNumber },
});

export const fetchAdmissionsByPhoneNumberSuccess = (admissions) => ({
  type: FETCH_ADMISSIONS_BY_PHONE_NUMBER_SUCCESS,
  payload: { admissions },
});

export const fetchAdmissionsByPhoneNumberFailure = (error) => ({
  type: FETCH_ADMISSIONS_BY_PHONE_NUMBER_FAILURE,
  payload: { error },
});

export const resetAdmissionsByPhoneNumber = () => ({
  type: RESET_ADMISSIONS_BY_PHONE_NUMBER,
});


export const editAdmission = (admissionId, admissionData) => ({
  type: EDIT_ADMISSION_REQUEST,
  payload: { admissionId, admissionData }
});

export const editAdmissionSuccess = (admission) => ({
  type: EDIT_ADMISSION_SUCCESS,
  payload: { admission }
});

export const editAdmissionFailure = (error) => ({
  type: EDIT_ADMISSION_FAILURE,
  payload: { error }
});

export const fetchAdmissionParticular = (admissionId) => ({
  type: FETCH_ADMISSION_PARTICULAR_REQUEST,
  payload: { admissionId },
});

export const fetchAdmissionParticularSuccess = (admission) => ({
  type: FETCH_ADMISSION_PARTICULAR_SUCCESS,
  payload: { admission },
});

export const fetchAdmissionParticularFailure = (error) => ({
  type: FETCH_ADMISSION_PARTICULAR_FAILURE,
  payload: { error },
});

export const resetAdmissionParticular = () => ({
  type: RESET_ADMISSION_PARTICULAR,
});

export const bulkDischargeAdmission = (data) => ({
  type: BULK_DISCHARGE_ADMISSION_REQUEST,
  payload: { data },
});

export const bulkDischargeAdmissionSuccess = (response) => ({
  type: BULK_DISCHARGE_ADMISSION_SUCCESS,
  payload: { response },
});

export const bulkDischargeAdmissionFailure = (error) => ({
  type: BULK_DISCHARGE_ADMISSION_FAILURE,
  payload: { error },
});
